/** @jsxImportSource @emotion/react */
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio as MuiRadio, FormHelperText } from '@mui/material'
import * as classes from './styles'

export type RadioProps<Item> = {
  label?: string
  items: Item[]
  value: Item | null
  onChange: (value: Item | null) => void
  error?: boolean
  helperText?: string
  row?: boolean
}

export function Radio<Item extends { id: string; title?: string }>({
  label,
  items,
  value,
  onChange,
  error,
  helperText,
  row,
}: RadioProps<Item>) {
  return (
    <FormControl component="fieldset" error={error} fullWidth>
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <RadioGroup
        row={row}
        value={value?.id ?? ''}
        onChange={(e) => {
          const selected = items.find((item) => item.id === e.target.value) ?? null
          onChange(selected)
        }}
        css={classes.radioGroup}
      >
        {items.map((item) => (
          <FormControlLabel
            key={item.id}
            value={item.id}
            control={<MuiRadio />}
            label={item.title}
            css={classes.radio}
          />
        ))}
      </RadioGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}
